import { useDispatch } from 'react-redux'
import {
  Checkbox,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Popover,
} from '@mui/material'
import { selectInvoicesHeaders } from 'lib/helpers/selectors'
import {
  invoicesTableColumnHeaderLabelMap,
  unavailableColumnsForInvoiceDrafts,
} from 'lib/utils/Invoices/invoices.utils'
import { useAppSelector } from 'store/hooks'
import { setHeaderValue } from 'actions/invoices'
import { useCFDIsContainerContext } from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import './styles.scss'

const DynamicCFDIsTableColumnMenu = () => {
  const { isInvoiceDraftsTab, tableHeadersAnchor, updateState } =
    useCFDIsContainerContext()

  const dispatch = useDispatch()

  const invoiceHeaders = useAppSelector(selectInvoicesHeaders)

  const completeInvoiceHeadersEntries = Object.entries(invoiceHeaders)
  const invoiceDraftHeadersEntries = completeInvoiceHeadersEntries.filter(
    ([key]) =>
      !unavailableColumnsForInvoiceDrafts.includes(key) && key !== 'createdAt'
  )

  const relevantInvoiceHeaderValues = (
    isInvoiceDraftsTab
      ? invoiceDraftHeadersEntries.map(([, value]) => value)
      : Object.values(invoiceHeaders)
  ) as boolean[]
  const relevantInvoiceHeaderKeys: string[] = isInvoiceDraftsTab
    ? invoiceDraftHeadersEntries.map(([key]) => key)
    : Object.keys(invoiceHeaders)

  return (
    <Popover
      className="dynamic-invoices-table-columns-menu-component"
      anchorEl={tableHeadersAnchor}
      keepMounted
      open={Boolean(tableHeadersAnchor)}
      onClose={() =>
        updateState(draft => {
          draft.tableHeadersAnchor = null
        })
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
      <List id="tableHeadersList" className="table-headers-list" dense>
        {relevantInvoiceHeaderKeys.map((key, i) => {
          return (
            <ListItem id={`tableHeadersListItem_${key}`} key={key}>
              <ListItemText
                id={key}
                primary={invoicesTableColumnHeaderLabelMap[key]}
              />
              <ListItemSecondaryAction>
                <Checkbox
                  color="secondary"
                  edge="end"
                  inputProps={{
                    'aria-labelledby': invoicesTableColumnHeaderLabelMap[key],
                  }}
                  tabIndex={-1}
                  checked={relevantInvoiceHeaderValues[i]}
                  onClick={() =>
                    dispatch(
                      setHeaderValue(key, !relevantInvoiceHeaderValues[i])
                    )
                  }
                />
              </ListItemSecondaryAction>
            </ListItem>
          )
        })}
      </List>
    </Popover>
  )
}

export default DynamicCFDIsTableColumnMenu
